<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            会話履歴のダウンロード
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-primary" has-icon>
              選択したロボの会話履歴のダウンロードを実行します。
            </b-message>
          </p>
          <hr>
          <section>
            <b-radio v-model="radioPeriod"
                name="period"
                native-value="allPeriod">
                全期間取得
            </b-radio>
            <b-radio v-model="radioPeriod"
                name="period"
                native-value="selectPeriod">
                取得期間指定
            </b-radio>
            <hr>
            <form id="selectStartDate">
              <p :disabled="isAllPeriod">取得開始日</p>
              <select v-model="startYear" @change="getStartDays" :disabled="isAllPeriod">
                <option v-for="n in yearSpan" :value="n + 2017" :key="n">
                  {{ n + 2017 }}
                </option>
              </select>年
              <select v-model="startMonth" @change="getStartDays" :disabled="isAllPeriod">
                <option v-for="n in 12" :value="n" :key="n">
                  {{ n }}
                </option>
              </select>月
              <select v-model="startDay" :disabled="isAllPeriod">
                <option v-for="n in startDaysMax" :value="n" :key="n">
                  {{ n }}
                </option>
              </select>日
            </form>
            <span style="color: white; display: flex; justify-content: center; align-items: center; margin: 5px;" class="mdi mdi-current-ac"></span>
              <p :disabled="isAllPeriod">取得終了日</p>
            <form id="selectEndDate">
              <select v-model="endYear" @change="getEndDays" :disabled="isAllPeriod">
                <option v-for="n in yearSpan" :value="n + 2017" :key="n">
                  {{ n + 2017 }}
                </option>
              </select>年
              <select v-model="endMonth" @change="getEndDays" :disabled="isAllPeriod">
                <option v-for="n in 12" :value="n" :key="n">
                  {{ n }}
                </option>
              </select>月
              <select v-model="endDay" :disabled="isAllPeriod">
                <option v-for="n in endDaysMax" :value="n" :key="n">
                  {{ n }}
                </option>
              </select>日
            </form>
          </section>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCardModalActive = false">閉じる</a>
          <a class="card-footer-item" @click="clickDownloadTalkHistory()">ダウンロード</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  name: 'ModalDownloadTalkHistory',
  data () {
    return {
      yearSpan          : 0,
      startDaysMax      : 0,
      startYear         : '',
      startMonth        : '',
      startDay          : '',
      endDaysMax        : 0,
      endYear           : '',
      endMonth          : '',
      endDay            : '',
      bots              : [],
      isCardModalActive : false,
      radioPeriod       : 'allPeriod',
      isAllPeriod       : true,
      startPeriod       : null,
      endPeriod         : null
    }
  },
  computed: {
    ...mapState('auth', ['user'])
  },
  watch: {
    radioPeriod () {
      console.debug('*** Start *** radioPeriod')
      if (this.radioPeriod === 'allPeriod') {
        // 全期間取得
        this.isAllPeriod = true
        console.debug('allPeriod')
      } else {
        // 取得期間指定
        this.isAllPeriod = false
        console.debug('selectPeriod')
      }
      console.debug('*** End *** radioPeriod')
    }
  },
  mounted () {
    const today      = moment()
    this.yearSpan    = today.year() - 2017
    this.radioPeriod = 'allPeriod'
    // 取得開始日初期値
    this.startYear   = today.year()
    this.startMonth  = today.month() + 1
    this.getStartDays()
    this.startDay    = today.date()
    // 取得終了日初期値
    this.endYear     = today.year()
    this.endMonth    = today.month() + 1
    this.getEndDays()
    this.endDay      = today.date()
  },
  methods: {
    getStartDays () {
      // 月の最大日取得
      this.startDaysMax = moment(this.startYear + '-' + this.startMonth, 'YYYY-MM').daysInMonth()
      if (this.startDay > this.startDaysMax) {
        // 設定済みの日が月の最大値を超える場合は1日にする
        this.startDay = 1
      }
    },
    getEndDays () {
      // 月の最大日取得
      this.endDaysMax = moment(this.endYear + '-' + this.endMonth, 'YYYY-MM').daysInMonth()
      if (this.endDay > this.endDaysMax) {
        // 設定済みの日が月の最大値を超える場合は1日にする
        this.endDay = 1
      }
    },
    clickDownloadTalkHistory () {
      console.debug('*** Start *** clickDownloadTalkHistory')
      // 期間チェック
      var startDate = null
      var endDate = null
      if (this.radioPeriod === 'selectPeriod') {
        // 期間指定
        console.debug('*** selectPeriod ***')
        // 取得開始日の00:00:00から取得終了日の23:59:59までに時間調整
        startDate = moment([this.startYear, this.startMonth - 1, this.startDay]).format('YYYY-MM-DD HH:mm:ss').toString()
        endDate = moment([this.endYear, this.endMonth - 1, this.endDay]).add('days', +1).add('second', -1).format('YYYY-MM-DD HH:mm:ss').toString()
        if (startDate > endDate) {
          // 期間逆指定
          alert('取得開始日を取得終了日以前か同日にしてください。')
          return
        }
      }

      // 会話履歴ダウンロード情報
      var jstz = require('jstimezonedetect')
      var data = {
        'bots'        : this.bots,
        'isAllPeriod' : this.isAllPeriod,
        'startPeriod' : startDate,
        'endPeriod'   : endDate,
        'period_tz'   : jstz.determine().name()
      }
      console.debug('send data: ' + JSON.stringify(data))

      // 会話履歴CSVダウンロード
      this.$store.dispatch('directtalk/makeDialogCSV', data)

      this.isCardModalActive = false
      this.$emit('getChatBots', this.bots)
      console.debug('*** End *** clickDownloadTalkHistory')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalDownloadTalkHistory.vue